import toast from 'react-hot-toast';
import { X } from 'lucide-react';
import CategoryIcon from './CategoryIcon';

const NotificationToast = ({ visible, notification, onOpen, onDismiss }) => (
  <div
    role="alert"
    className={`transition-all duration-200 ${
      visible ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-2'
    } w-[360px] max-w-[calc(100vw-2rem)] bg-white shadow-lg rounded-xl border border-gray-100 flex items-start gap-3 p-3`}
  >
    <button
      type="button"
      onClick={onOpen}
      className="flex items-start gap-3 flex-1 min-w-0 text-left"
    >
      <CategoryIcon category={notification.category} size={34} />
      <span className="min-w-0 flex-1">
        <span className="block text-sm font-semibold text-gray-900 truncate">
          {notification.title}
        </span>
        <span className="block text-xs text-gray-500 mt-0.5 line-clamp-2">
          {notification.message}
        </span>
      </span>
    </button>
    <button
      type="button"
      onClick={onDismiss}
      aria-label="Dismiss notification"
      className="p-1 rounded-md text-gray-400 hover:text-gray-600 hover:bg-gray-50"
    >
      <X size={14} />
    </button>
  </div>
);

export const showNotificationToast = (notification, onOpen) => {
  if (!notification?.id) return;
  toast.custom(
    (t) => (
      <NotificationToast
        visible={t.visible}
        notification={notification}
        onOpen={() => {
          toast.dismiss(t.id);
          onOpen(notification);
        }}
        onDismiss={() => toast.dismiss(t.id)}
      />
    ),
    {
      id: `notification-${notification.id}`,
      duration: notification.priority === 'high' ? 10_000 : 6_000,
      position: 'top-right',
    }
  );
};

export default NotificationToast;
